import { render, staticRenderFns } from "./YkCampDistributionRequests.vue?vue&type=template&id=c231b224&"
import script from "./YkCampDistributionRequests.vue?vue&type=script&lang=js&"
export * from "./YkCampDistributionRequests.vue?vue&type=script&lang=js&"
import style0 from "./YkCampDistributionRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports